import { render, staticRenderFns } from "./PocketPivot.vue?vue&type=template&id=712c9356&scoped=true"
import script from "./PocketPivot.vue?vue&type=script&lang=js"
export * from "./PocketPivot.vue?vue&type=script&lang=js"
import style0 from "./PocketPivot.vue?vue&type=style&index=0&id=712c9356&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "712c9356",
  null
  
)

export default component.exports